import { css as _css } from "@emotion/core";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import { BedIcon, BathIcon, ParkingIcon, DevelopmentIcon, LeisureIcon, IndustrialIcon, OfficeIcon, RetailIcon, BuildingIcon, DevelopmentSizeIcon, EerIcon } from '@domain-group/fe-co-icon';
import { ListingType, PropertyType } from '@domain-group/fe-allhomes-library';
import Features from '../../models/property';
import * as styles from './features.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DEFAULT_PROPERTY_ICON = BuildingIcon;
var SizeIcon = DevelopmentSizeIcon;
var Icons = {
  [PropertyType.COMMERCIAL_LAND.name]: DevelopmentIcon,
  [PropertyType.HOTEL.name]: LeisureIcon,
  [PropertyType.INDUSTRIAL.name]: IndustrialIcon,
  [PropertyType.MOTEL.name]: LeisureIcon,
  [PropertyType.OFFICE.name]: OfficeIcon,
  [PropertyType.RETAIL.name]: RetailIcon,
  [PropertyType.WAREHOUSE.name]: IndustrialIcon,
  [PropertyType.OTHER_COMMERCIAL.name]: BuildingIcon
};
var AllhomesListingCardFeatures = props => {
  var eer = props.eer && Number(props.eer);
  var renderFeatureIcon = (value, IconElem, title) => {
    if (value) {
      return ___EmotionJSX("span", {
        css: styles.feature
      }, ___EmotionJSX(IconElem, {
        size: "custom",
        css: styles.featureIcon,
        title: title
      }), ___EmotionJSX("span", {
        css: styles.featureValue
      }, value));
    }
    return null;
  };
  var isResi = props.listingType === ListingType.SALES_RESIDENTIAL.name || props.listingType === ListingType.RENTAL_RESIDENTIAL.name || props.listingType === ListingType.SHARE_RESIDENTIAL.name;
  var showEer = isResi && props.listingType !== ListingType.SHARE_RESIDENTIAL.name && !!eer && eer >= 0;
  var isCommercial = props.listingType === ListingType.SALES_COMMERCIAL.name || props.listingType === ListingType.RENTAL_COMMERCIAL.name;
  var displayPropertyType = (isResi || isCommercial) && (props.media.mobile && props.type.length <= 5 || !props.media.mobile);
  var hasTypeSeparator = Boolean(isResi && (props.beds || props.baths || props.cars || eer) || props.size && isCommercial);
  var PropertyTypeIcon = Icons[props.type.toUpperCase()] || DEFAULT_PROPERTY_ICON;
  return ___EmotionJSX("div", {
    css: styles.features
  }, isResi && ___EmotionJSX("div", {
    css: styles.featuresIcons
  }, renderFeatureIcon(props.beds, BedIcon, 'Bedrooms'), renderFeatureIcon(props.baths, BathIcon, 'Bathrooms'), renderFeatureIcon(props.parking, ParkingIcon, 'Parking'), showEer && renderFeatureIcon(eer.toFixed(1), EerIcon, 'EER')), props.size && props.size > 0 && isCommercial && ___EmotionJSX("div", {
    css: styles.size
  }, ___EmotionJSX(SizeIcon, null), ___EmotionJSX("span", {
    css: styles.sizeValue
  }, props.size, " m", ___EmotionJSX("span", {
    css: styles.sizeSuperscript
  }, "2"))), props.type && displayPropertyType && ___EmotionJSX("div", {
    css: styles.type
  }, isCommercial && ___EmotionJSX(PropertyTypeIcon, null), (isResi || isCommercial) && ___EmotionJSX("span", {
    css: /*#__PURE__*/_css([styles.typeValue, hasTypeSeparator && styles.separator])
  }, props.type)));
};
AllhomesListingCardFeatures.propTypes = _objectSpread(_objectSpread({}, Features), {}, {
  media: PropTypes.shape({}).isRequired,
  listingType: PropTypes.string.isRequired
});

/* eslint-disable react/default-props-match-prop-types */
AllhomesListingCardFeatures.defaultProps = {
  beds: undefined,
  bath: undefined,
  parking: undefined,
  type: undefined,
  size: undefined,
  eer: undefined
};
export default withMedia(AllhomesListingCardFeatures);
export { AllhomesListingCardFeatures as BaseAllhomesListingCardFeatures };